/**
 * Вытаскивает искомое поле из заголовков конфигов запроса Axios
 */
export function getRequestConfigHeaderField(requestConfig, field) {
    const resultField = requestConfig.headers?.[field];
    return typeof resultField === 'string' ? resultField : undefined;
}
